import { Injectable } from "@angular/core";
import { PathLocationStrategy } from "@angular/common";
import { ClientLogProvider } from "../providers/client-log/client-log";
import { Auth } from "../providers/auth/auth";
import { IonicErrorHandler } from "ionic-angular";
import { Me } from "../models/user";
import { AppConfig } from "./app.config";
import * as StackTrace from "stacktrace-js";

@Injectable()
export class GlobalErrorHandler extends IonicErrorHandler {
  constructor(
    private auth: Auth,
    private clientLogProvider: ClientLogProvider
  ) {
    super();
  }

  handleError(error) {
    const message = error.message ? error.message : error.toString();
    const url = location instanceof PathLocationStrategy ? location.path() : "";

    const user: Me = this.auth.getMe() || new Me({});

    if (AppConfig.ENV === "production") {
      // get the stack trace, lets grab the last 10 stacks only
      StackTrace.fromError(error).then((stackframes) => {
        const stackString = stackframes
          .splice(0, 20)
          .map((sf) => sf.toString())
          .join("\n");
        // log on the server
        this.clientLogProvider.post({
          user_id: user.id,
          message: message,
          url: url,
          stack: stackString,
        });
      });

      // const alertCtrl = this.injector.get(AlertController);
      // const alert = alertCtrl.create({
      //   title: "エラー",
      //   subTitle: "予期せぬエラーが起きました。アプリを再起動します。",
      //   buttons: [
      //     {
      //       text: "ok",
      //       handler: () => {
      //         window.location.href = window.location.pathname;
      //       }
      //     },
      //   ]
      // });
      // alert.present();

      super.handleError(error);
    } else {
      super.handleError(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/error-handler.ts